var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"footer"}},[_c('contact'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('a',{staticClass:"footer_link",attrs:{"href":"https://www.ctc-g.co.jp/","target":"_blank"}},[_vm._v("CTCコーポレートサイトへ")]),_c('span',[_vm._v("(C) ITOCHU Techno-Solutions Corporation.")])])
}]

export { render, staticRenderFns }